"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORG_PAGE_FOOTER_BLOCK_CONTENT_MAX_LENGTH = exports.ORG_PAGE_FOOTER_BLOCK_TITLE_MAX_LENGTH = exports.ORG_PAGE_FOOTER_BLOCK_MAX_COUNT = exports.buildOrgPageFooterAddressMapsUrl = exports.formatOrgPageFooterAddress = exports.ORG_PAGE_DEFAULT_SOCIAL_PLATFORMS = void 0;
const address_1 = require("./address");
const country_1 = require("./country");
exports.ORG_PAGE_DEFAULT_SOCIAL_PLATFORMS = ["Facebook", "X", "YouTube"];
const formatOrgPageFooterAddress = ({ address, city, region, postalCode }) => (0, address_1.formatAddress)({ address, city, region, postalCode });
exports.formatOrgPageFooterAddress = formatOrgPageFooterAddress;
const buildOrgPageFooterAddressMapsUrl = (footerAddress) => {
    const query = (0, address_1.formatAddress)({
        ...footerAddress,
        country: (0, country_1.convertCountryCodeToCountryName)(footerAddress.countryCode) ?? footerAddress.countryCode,
    });
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
};
exports.buildOrgPageFooterAddressMapsUrl = buildOrgPageFooterAddressMapsUrl;
exports.ORG_PAGE_FOOTER_BLOCK_MAX_COUNT = 50;
exports.ORG_PAGE_FOOTER_BLOCK_TITLE_MAX_LENGTH = 100;
exports.ORG_PAGE_FOOTER_BLOCK_CONTENT_MAX_LENGTH = 500;
